import React from "react";
import "./Avatar.scss";

const Avatar = (props) => (
    <img src={props.avatar} className="avatar bg-transparent border border-light" alt={props.name}></img>
);

export default Avatar;